import styled from "styled-components";
import {colors} from "../../common/ui/globalColors";

export const StyledMessagePlatform = styled.div`
  display: grid;
  gap: 30px;

  .title {
    display: grid;
    gap: 50px;
  }
`

export const StyledMessagePlatformList = styled.div`
  border: 1px solid rgba(110, 116, 255, 0.4);
  border-radius: 28px;
  padding: 27px 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 30px;

  .contacts-wrapper {
    display: grid;
    width: fit-content;
    min-width: 270px;
    gap: 15px;

    .select-dropdown {
      position: relative;
      display: grid;
      gap: 5px;
      width: 66%;

      #select-wrapper {
        position: relative;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: fit-content;
        border:none;
        box-shadow: 2px 3px 7px 0 ${colors.semiTransparentColors.purple};
      }

      #select-wrapper label {
        margin: 0px;
      }

      #arrow-btn {
        width: 25px;
        height: 25px;
        background-color: ${colors.additionalColors.lightGray};
        border-radius: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 2px 3px 7px 0 ${colors.semiTransparentColors.gray};
      }
    }
  }

  textarea {
    border-radius: 20px;
    resize: none;
  }

  .switch-btns-wrapper {
    display: flex;
    gap: 15px;

    .switch-btn {
      width: 210px;
      height: 38px;
      border: 1px solid rgba(110, 116, 255, 0.2);
      border-radius: 100px;
      font-size: 16px;
      line-height: 18px;
      position: relative;
      cursor: pointer;
      padding: 11px 20px;
      display: flex;
      align-items: center;
      gap: 12px;

      .radio-btn-outer {
        width: 16px;
        height: 16px;
        border: 1px solid rgba(110, 116, 255, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: ${({ltr}) => ltr ? '10px' : ''};
        left: ${({ltr}) => ltr ? '' : '10px'};

        .radio-btn-inner {
          width: 6.4px;
          height: 6.4px;
          background: rgba(110, 116, 255, 0.2);
          border-radius: 50%;
        }
      }
    }

    .switch-btn.active {
      background-color: #E9E9FD;
      border: none;
      font-weight: bold;

      .radio-btn-outer {
        border: 1px solid #6A92FF;

        .radio-btn-inner {
          background: linear-gradient(50.53deg, #6A92FF 20.83%, #8764FF 86.02%);
        }
      }
    }
  }

  .message-content {
    width: 70%;
    display: grid;
    gap: 4px;
    @media screen and (max-width: 768px) {
      width: 90%;
      textarea {
        position: center;
      }
    }

    .message-properties {
      display: flex;
      align-items: center;
      justify-content: space-between;

      label {
        margin: 0px;
      }

      .customize-content {
        display: grid;
      }

      .customized-content-wrapper {
        .addBtnContainer {
          position: relative;
          display: flex;
          align-items: center;
          gap: 10px;
          margin-left: 25px;

          label {
            margin: 0;
          }

          #addBtn {
            width: 32px;
            height: 32px;
            background-color: ${colors.additionalColors.lightGray};
            border-radius: 50px;
            cursor: pointer;
            left: 3px;
            top: 10px;
            display: flex;
            flex-direction: column;
            gap: 3px;
            align-items: center;
            justify-content: center;
            box-shadow: -2px 3px 7px 0 ${colors.semiTransparentColors.gray};

            :hover {
              background: linear-gradient(180deg, ${colors.additionalColors.brightBlue} 0%, ${colors.additionalColors.purple} 100%);
              color: ${colors.textColors.white};
            }
          }
        }

        .customized-content-pop-up {
          position: absolute;
          background: white;
          box-shadow: 0px 5px 30px rgba(89, 102, 137, 0.3);
          border-radius: 11px;
          padding: 12px 22px;
          margin-top: 10px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 7px;
          z-index: 999;

          .customized-content {
            background: ${colors.additionalColors.lightGray};
            color: var(--bllink-gray);
            font-weight: normal;
          }
        }
      }
    }
  }

  .sender-name-input {
    display: flex; {
    align-items: center;
    gap: 10px;

    label {
      margin: 0;
    }

    textarea {
      width: 25%;
      min-width: 270px;
    }
  }
  }

  .send-button {
    width: auto;
    display: flex;
    flex-direction: row;
    justify-content: end;
  }
`

export const StyledAutoCampaignCard = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  direction: ${({ltr}) => ltr ? 'ltr' : 'rtl'};

  .card {
    width: 100%;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid ${colors.additionalColors.lightBlue};
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 11px;
    padding: 8px 20px;
    display: grid;
    grid-template-columns: ${({inMonitoring}) => inMonitoring ? 'repeat(8, 1fr)' : 'repeat(6, 1fr)'};
    text-align: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: rgba(55, 54, 71, 0.7);
  }
`